<template>
  <div>
    <userroleview
      :userroleinfo="userRoleInfo"
      :userrolecontacts="userRoleContacts"
      :orgcontacts="orgContacts"
      :allmodules="allModules"
      @userRoleContactChange="getUserRoleContacts"
    ></userroleview>
  </div>
</template>

<script>
import Api from "@/services/Api";
import UserRoleView from "@/components/UserRoleView.vue";

export default {
  components: {
    userroleview: UserRoleView
  },
  data() {
    return {
      userRoles: [],
      userGroups: [],
      allModules: [],
      allOrgModuleId: [],
      allOrgModules: [],
      userRoleInfo: null,
      userRoleContacts: [],
      orgContacts: []
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.getOrgModules();
      this.getUserRoleInfo();
      this.getUserRoleContacts();
      this.getOrgContacts();
    },
    async getOrgModules() {
      this.allOrgModules = [];
      this.allOrgModuleId = [];
      await Api()
        .get("/organisationModule")
        .then(async response => {
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].module.isActive &&
              !response.data[i].module.isDeleted
            ) {
              await this.allOrgModules.push(response.data[i].module);
              await this.allOrgModuleId.push(response.data[i].moduleId);
            }
          }
        });
    },
    async getOrgContacts() {
      this.orgContacts = [];
      await Api()
        .get("/organisationContact")
        .then(response => {
          this.orgContacts = response.data
          console.log(this.orgContacts)
          // for (let i = 0; i < response.data.length; i++) {
          //   if (response.data[i].isActive && !response.data[i].isDeleted) {
          //     this.orgContacts.push(response.data[i].contact);
          //   }
          // }
        });
    },
    async getUserRoleContacts() {
      this.userRoleContacts = [];
      await Api()
        .get("/userRoleContact/byUserRole/" + this.$route.params.userRoleId)
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].isActive &&
              !response.data[i].isDeleted &&
              response.data[i].contact !== null
            ) {
              this.userRoleContacts.push({
                id: response.data[i].id,
                contact: response.data[i].contact
              });
            }
          }
        });
    },
    async getUserRoleInfo() {
      await Api()
        .get("/userRole/" + this.$route.params.userRoleId)
        .then(async response => {
          this.userRoleInfo = response.data;
          let modules = [];
          let moduleSubmodules = [];
          let moduleId = [];
          let moduleSumbmoduleId = [];
          this.userRoleInfo.routePermissions = await this.userRoleInfo.routePermissions.filter(x=>x.moduleSubmodule&&x.moduleSubmodule.module !== null)
          for (let i = 0; i < this.userRoleInfo.routePermissions.length; i++) {
            if (
              !moduleId.includes(
                this.userRoleInfo.routePermissions[i].moduleSubmodule.module.id
              ) &&
              this.allOrgModuleId.includes(
                this.userRoleInfo.routePermissions[i].moduleSubmodule.module.id
              )
            ) {
              await modules.push({
                moduleId: this.userRoleInfo.routePermissions[i].moduleSubmodule
                  .module.id,
                moduleName: this.userRoleInfo.routePermissions[i]
                  .moduleSubmodule.module.name,
                moduleDescription: this.userRoleInfo.routePermissions[i]
                  .moduleSubmodule.module.description
              });
            }
            if (
              !moduleId.includes(
                this.userRoleInfo.routePermissions[i].moduleSubmodule.module.id
              )
            ) {
              await moduleId.push(
                this.userRoleInfo.routePermissions[i].moduleSubmodule.module.id
              );
            }

            if (
              !moduleSumbmoduleId.includes(
                this.userRoleInfo.routePermissions[i].moduleSubmoduleId
              )
            ) {
              await moduleSumbmoduleId.push(
                this.userRoleInfo.routePermissions[i].moduleSubmoduleId
              );
              await moduleSubmodules.push(
                this.userRoleInfo.routePermissions[i]
              );
            }
          }
          for (let x = 0; x < modules.length; x++) {
            let submodules = await moduleSubmodules.filter(function(el) {
              return (
                el.moduleSubmodule.moduleId === modules[x].moduleId &&
                el.moduleSubmodule.submodule.isActive === true &&
                el.moduleSubmodule.submodule.isDeleted === false
              );
            });
            if (typeof modules[x].submodules === "undefined") {
              modules[x].submodules = submodules;
            }
            modules[x].submodules.sort((a, b) =>
              a.moduleSubmodule.submodule.name >
              b.moduleSubmodule.submodule.name
                ? 1
                : b.moduleSubmodule.submodule.name >
                  a.moduleSubmodule.submodule.name
                ? -1
                : 0
            );

            for (let y = 0; y < modules[x].submodules.length; y++) {
              for (let z = 0; z < moduleSubmodules.length; z++) {
                if (
                  moduleSubmodules[z].moduleSubmodule.submoduleId ===
                  modules[x].submodules[y].submoduleId
                ) {
                  (modules[x].submodules[y].create =
                    moduleSubmodules[z].create),
                    (modules[x].submodules[y].read = moduleSubmodules[z].read),
                    (modules[x].submodules[y].update =
                      moduleSubmodules[z].update),
                    (modules[x].submodules[y].delete =
                      moduleSubmodules[z].delete),
                    (modules[x].submodules[y].admin =
                      moduleSubmodules[z].admin);
                }
              }
            }
          }
          this.allModules = modules;
        });
    },
    getUserRoles() {
      Api()
        .get("/userRole")
        .then(response => {
          this.userRoles = response.data;
        });
    },
    getUserGroups() {
      Api()
        .get("/userGroup")
        .then(response => {
          this.userGroups = response.data;
        });
    }
  }
};
</script>

<style>
</style>